import timezones from "constants/timezones/AllTimezonesArray";

export const timezoneOptions = timezones.all_timezones.map((item) => ({
  ...item,
  id: `${item.label}__${item.country_code}__${item.value}`,
}));
